import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody35.css';

import clientimg from '../images/case-study-client35.webp'
import outcome from '../images/outcome35.webp'

import sm1 from '../images/cs35so1.webp'
import sm2 from '../images/cs35so2.webp'
import sm3 from '../images/cs35so3.webp'
import sm4 from '../images/cs35so4.webp'


const Casestudybody35 = () => {

    return (
        <>
          <section className='casestudybody35-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A leading real estate investment, development, and property management company in the Middle East, recognized for executing high-quality projects and consistently delivering strong returns to stakeholders </p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client aimed to raise USD ~1 Bn through a Private Placement Offer (PPO) and required an annual company valuation in line with their strategic objectives</p>
                </div>
                
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody35-section bg-gredient-dark'>
        <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology:</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    <div className='text'>
                            {/* <p>Our team employed a structured and detailed process to meet the client's specific requirements:</p> */}
                        </div>
                    
                    <div><span className='method-stage'>Sum of the Parts (SOTP) Valuation Methodology</span></div>
                
                    <div className='list-text my-3'>
                        <div className='icon'>
                        
                        </div>
                        <div className='text'>
                            <p>The Company was valued using the Discounted Cash Flow (DCF) approach. The following sources of income were valued to derive the <span style={{color:"#03A393"}}> company valuation:</span> </p>

                          
                            <div className='list-text my-3'>
                              <div className='icon'>
                              <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                              </svg>
                              </div>
                              <div className='text'>
                                <h4>Developer Management Fees (DMFs): </h4>
                                <p>This fee is earned for <span style={{color:"#03A393"}}> managing the construction and delivery of projects.</span> The cash flows generated from the active development projects were discounted back, and the terminal value was added for the departmental valuation to reflect the long-term capability of the development team to manage and generate revenue from development activities</p>
                              </div>
                            </div>

                            <div className='list-text my-3'>
                              <div className='icon'>
                              <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                              </svg>
                              </div>
                              <div className='text'>
                                <h4>Property Management Fees (PMFs): </h4>
                                <p>The <span style={{color:"#03A393"}}>valuation is based on projected income</span> from managing active property operations, along with a terminal value. This combined approach captures both current earnings potential and long-term value</p>
                              </div>
                            </div>

                            <div className='list-text my-3'>
                              <div className='icon'>
                              <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                              </svg>
                              </div>
                              <div className='text'>
                                <h4>Real Estate Equity Investments:</h4>
                                <p>The valuation considers <span style={{color:"#03A393"}}> dividends received from real estate projects</span> in which the company holds equity stakes. The projected five-year cash flows from these investments and the terminal value were discounted to their present value to determine the market value</p>
                              </div>
                            </div>
          
                        </div>
                      </div>


                     <div><span className='method-stage'>Workshops</span></div>
                
                    <div className='list-text my-3'>
                        <div className='icon'>
                        
                        </div>
                        <div className='text'>
                            <p>Conducted <span style={{color:"#03A393"}}>  collaborative workshops with key stakeholders</span> from each department to gain an in-depth understanding of project activities and steps involved</p>
                        </div>
                      </div>


                      <div><span className='method-stage'>Identification of Key Outcomes & Desired State</span></div>
                
                    <div className='list-text my-3'>
                        <div className='icon'>
                        
                        </div>
                        <div className='text'>
                            <p>The outcome was to <span style={{color:"#03A393"}}> estimate the company's value to support fundraising, understand potential ownership changes, and guide investor discussions</span>. The desired state was a data-driven valuation framework backed by thorough research to support strategic decisions</p>
                        </div>
                      </div>

                 
                      <h3 className='mt-5'>Sample Output</h3>
                      {/* <p><span style={{fontWeight:700}}>Case in Point:</span> We meticulously prepared a comprehensive Portfolio Dashboard and an in-depth Fund Summary. These tools assisted in quickly extracting the performance summary of the fund without much client's involvement.</p> */}
                      <div className='sample-output1 mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                       
                      </div>
            
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody35-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>Developed a detailed company-level valuation model incorporating multiple scenarios in line with the client's strategic objectives. The analysis enabled the client to determine the most effective strategy for raising USD ~1 Bn through a partial equity sale and provided a strong foundation for attracting and onboarding new investors</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody35
